export default __webpack_public_path__ + "static/media/checkedNew-white.d11c900a.svg";